import {MessageBox} from "element-ui";
import i18n from "@/config/i18n"

/**
 * 构建渲染树形结构
 * @param list 需要构建的数组
 * @param format 格式化函数
 * @param level 当前层级
 * @returns {*}
 */
export const handleBuildTreeData = (list, format, level = 1) => {
  return list.map(item => {
    let sub = [];
    if (Array.isArray(item.sub) && item.sub.length) {
      sub = handleBuildTreeData(item.sub, format, level + 1);
    }
    // 自定格式化
    const formatParam = format ? format(item) : {};

    return {
      // 以下为表格字段
      ...item,
      ...formatParam,
      // isFirstRow: !item.parentCode, // 是否一级
      isFirstRow: level === 1, // 是否一级
      sub, // 子集
      level,
    }
  })
}

/**
 * 删除树节点
 * @param ids 要删除的节点id
 * @param source 原始数据
 * @returns {*}
 */
export const handleDeleteTreeNode = (ids, source) => {
  // 过滤掉被删除的row
  const fn = (list) => {
    return list.filter(item => {
      if (item.sub && item.sub.length) {
        item.sub = fn(item.sub);
      }
      return !ids.includes(item.code);
    })
  }
  return fn(source);
}

/**
 * 展开默认行
 * @param list 展开数组
 * @returns {*[]}
 */
export const handleExpandDefaultRow = (list) => {
  let keys = [];
  list.forEach(item => {
    if(item.expand === "yes" && item.children && item.children.length) {
      keys.push(item.id);
      let fn = (list) => {
        list.forEach(l => {
          keys.push(l.id);
          if(l.children.length) fn(l.children);
        })
      }
      fn(item.children);
    }
  })
  return keys;
}


/**
 * 删除提示
 */
export const handleDeleteTip = () => {
  return new Promise((resolve, reject) => {
    MessageBox.confirm(i18n.t('删除后不可恢复，确认删除？'), i18n.t('提示'),{
      confirmButtonText: i18n.t('确定'),
      cancelButtonText: i18n.t('取消'),
      type: 'warning'
    }).then(() => {
      resolve();
    }).catch(() => {
      reject();
    })
  })
}
